import { Notify } from 'vant';

export default function request(url, options, handleDefaultError = true) {
  return fetch(url, options)
    .then(parseJSON)
    .then((res) => {
      if (!res.code) return res;
      throw new Error(res.message);
    })
    .catch(handleDefaultError ? handleError : undefined);
}

function parseJSON(response) {
  return response.json();
}

function handleError(error) {
  Notify(error.message || '发生未知错误');
  throw error;
}